
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Calendar, Clock } from "lucide-react";

interface DateRangeFilterProps {
  selectedRange: string;
  onRangeChange: (range: string) => void;
}

export const DateRangeFilter = ({ selectedRange, onRangeChange }: DateRangeFilterProps) => {
  const dateRanges = [
    { value: 'today', label: 'Vandaag' },
    { value: 'yesterday', label: 'Gister' },
    { value: 'last7days', label: 'Afgelopen 7 dagen' },
    { value: 'thisWeek', label: 'Deze week' },
    { value: 'lastWeek', label: 'Vorige week' },
    { value: 'thisMonth', label: 'Deze maand' },
    { value: 'lastMonth', label: 'Vorige maand' },
    { value: 'last30days', label: 'Afgelopen 30 dagen' },
  ];

  return (
    <div className="flex items-center gap-3 bg-white p-4 rounded-lg border shadow-sm">
      <div className="flex items-center gap-2 text-gray-600">
        <Calendar className="h-4 w-4" />
        <span className="text-sm font-medium">Tijdsperiode:</span>
      </div>
      <Select value={selectedRange} onValueChange={onRangeChange}>
        <SelectTrigger className="w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {dateRanges.map((range) => (
            <SelectItem key={range.value} value={range.value}>
              <div className="flex items-center gap-2">
                <Clock className="h-3 w-3" />
                {range.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
